import React from 'react';
import {
  Select,
  Form,
  Input,
  // Tooltip
} from 'antd';
// import { ExclamationCircleOutlined } from '@ant-design/icons'
import { ACTIVITY_LEVELS, OTHER_LEVEL_CODE } from '@/constants';

const { Option } = Select;

function SelectActivityLevel() {
  return (
    <>
      <Form.Item
        label={
          <div>
            活动级别
            {/* <Tooltip title='活动级别将作为资源申请环节的主要审核条件之一，请正确填写，否则将会驳回相关的资源申请，并影响后续资源的申请，活动级别可修改，为保障营销活动各环节公平公正的实施，系统将会留存每一次资源申请时的活动信息。'>
              <ExclamationCircleOutlined />
            </Tooltip> */}
          </div>
        }
        name="level"
        rules={[
          {
            required: true,
            message: '请选择活动级别',
          },
        ]}
      >
        <Select
          showSearch
          optionFilterProp="children"
          filterOption={(input, option) => option.children.indexOf(input) >= 0}
          placeholder="请选择"
        >
          {ACTIVITY_LEVELS.slice(1).map((item) => (
            <Option key={item.val} value={item.val}>
              {item.title}
            </Option>
          ))}
        </Select>
      </Form.Item>
      <Form.Item shouldUpdate={(prevValue, curValue) => prevValue.level !== curValue.level} noStyle>
        {({ getFieldValue }) => {
          return getFieldValue('level') === OTHER_LEVEL_CODE ? (
            <Form.Item
              // wrapperCol={{ style: { marginLeft: '143px', flexGrow: 0, flexBasis: '380px' } }}
              rules={[
                {
                  required: true,
                  message: '活动级别不可为空',
                },
                {
                  max: 50,
                  message: '活动级别不能超过50个字符',
                },
              ]}
              name="otherLevel"
            >
              <Input placeholder="请输入50字以内的活动级别" />
            </Form.Item>
          ) : null;
        }}
      </Form.Item>
    </>
  );
}

export default SelectActivityLevel;
